import { Box } from "@mui/material";
import WorksView from "../../components/works-list/WorksView";
import FabEyeButton from "../../components/user-activity-fab/UserActivityFab";

const WorksPage = () => {
  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <WorksView />
      <FabEyeButton />
    </Box>
  );
};

export default WorksPage;
